export function formatNumber(value: number): string {
  const num = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(num);
}

export function formatMinutes(totalMinutes: number): string {
  const minutes = Number.isFinite(totalMinutes) ? Math.max(0, Math.round(totalMinutes || 0)) : 0;
  const withSep = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(minutes);
  return withSep;
}

export function formatPercent(value: number, fractionDigits = 0): string {
  const num = Number.isFinite(value) ? value : 0;
  return num.toFixed(fractionDigits);
}
